import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  // Bypass authentication - always allow access
  localStorage.setItem('isAdminAuthenticated', 'true');
  return children;
};

export default ProtectedRoute; 